import { gql } from '@apollo/client';

export const GET_DISCOUNTS = gql`
  query discounts {
    discounts {
      data {
        id
        title
        value
        entity
        is_tracked
        dont_use_on_holidays
        is_tracked
        schedules {
          end
          start
        }
        active
      }
    }
  }
`;

export const CREATE_DISCOUNT = gql`
  mutation createDiscount($input: DiscountInput!) {
    createDiscount(input: $input) {
      id
    }
  }
`;

export const UPDATE_DISCOUNT = gql`
  mutation UpdateDiscount(
    $updateDiscountId: Int!
    $input: DiscountUpdateInput!
  ) {
    updateDiscount(id: $updateDiscountId, input: $input) {
      id
    }
  }
`;

export const DELETE_DISCOUNT = gql`
  mutation deleteDiscount($id: Int!) {
    deleteDiscount(id: $id) {
      id
    }
  }
`;
